<div
  class="mat-caption"
  *ngFor="let item of context$ | ngrxPush; trackBy: trackByContext"
>
  <span
    class="context-key cursor-pointer"
    [cdkCopyToClipboard]="'{{ ' + item.key + ' }}'"
    matTooltip="Copy to clipboard"
    matTooltipShowDelay="300"
    matTooltipPosition="after"
    (click)="snackBar.open('Copied to clipboard'); selected.emit()"
    >{{ '{{ ' + item.key + ' }}' }}</span
  >
  {{ item.value }}
</div>
